import { Box } from "@mui/system";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/header/Header";
import SidebarContainer from "../components/Sidebar/SidebarContainer";
import useIsMobile from "../hooks/useIsMobile.hook";

const Layout = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const isLoginPage =
    location.pathname === "/" || location.pathname === "/auth";
  const noSideBar =
    location.pathname === "/welcome" || location.pathname === "/dashboard" || location.pathname === "/auditLogs" || location.pathname === "/unauthorized";


  return (
    <Box display="grid">
      {!isLoginPage && <Header />}

      <Box
        gridRow={2}
        sx={{
          backgroundColor: "#f5f5f2",
          display: "grid",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {!isLoginPage && !noSideBar && (
            <div style={{ display: "inline-flex" }}>
              <SidebarContainer />
            </div>
          )}
          <div
            style={
              !isMobile ? { flexGrow: 100, width: "100px" } : { width: "100vw" }
            }
          >
            <Outlet />
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default Layout;
